import { SVG } from './SVG';
const IconTwitterAlt1 = () => {
  return (
    <SVG width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 3.66992C22.0424 4.3454 20.9821 4.86203 19.86 5.19992C19.2577 4.50743 18.4573 4.01661 17.567 3.79385C16.6767 3.57108 15.7395 3.62712 14.8821 3.95438C14.0247 4.28163 13.2884 4.86432 12.773 5.62364C12.2575 6.38295 11.9877 7.28226 12 8.19992V9.19992C10.2426 9.24549 8.50127 8.85574 6.93101 8.06537C5.36074 7.275 4.01032 6.10856 3 4.66992C3 4.66992 -1 13.6699 8 17.6699C5.94053 19.0679 3.48716 19.7689 1 19.6699C10 24.6699 21 19.6699 21 8.16992C20.9991 7.89138 20.9723 7.61352 20.92 7.33992C21.9406 6.33342 22.6608 5.06263 23 3.66992Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export { IconTwitterAlt1 as default, IconTwitterAlt1 };
